// extracted by mini-css-extract-plugin
export default {"notification":"BrinkPOS_notification__J2tho"};